import React, { useState, useEffect } from "react";
import Footer from "../components/footer/footer";
import Header from "../components/header/header";
import Error from "./Error";
import Models from "./Models";
import DataDescriptions from "./DataDescriptions";
import Views from "./Views";
import Drawings from "./Drawings";
import * as miscAction from "../actions/miscAction";
import { connect } from "react-redux";
import DMTabContainer from "../components/common/controls/DMTabContainer";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { HasPermission } from "../utilities/applicationutils";
import * as dataDescriptionAction from "../actions/dataDescriptionAction";
import Loading from "../components/Loading/Loading";
import { IntlProvider } from "react-intl";
import {
  ApiService,
  cache,
  getTranslationData,
} from "@carrier-ecat/workflowui-globalfunctions";
import { appConfig } from "../environment/environments";
import {
  LOCALE_SET_PROJECTS,
  UPDATE_MESSAGES,
  LOCALE_SET_PROJECTS_TRANSLATIONS,
  UPDATE_TRANSLATIONS,
} from "../actionTypes/actionTypes";
import {
  getProjects,
  gettranslationForModel,
} from "../services/TranslationService";
import ConfigureMsg from "./ConfigureMsg";

var CONTROLS_DATA = require("./ControlsData.json");
const TRANSLATION_API_PROJECT_ID = "165";

const dumpTranslationData = () => {
  const data = {
    "30RC-232-STD-N.dxf": "30RC-232-STD-N.dxf",
    "30RC-092-CMPT-F.dxf": "30RC-092-CMPT-F.dxf",
  };

  const apiUrl =
    "https://translationservice.carrier.com/api/v1/translations?autoTranslate=1&NewKey=1";

  const token =
    "Bearer eyJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3MzY1NDk3NzYsIm5iZiI6MTczNjI1Mjc4MywidmVyIjoiMiIsImlzcyI6Imh0dHBzOi8vY29nbml0by1pZHAudXMtZWFzdC0yLmFtYXpvbmF3cy5jb20vdXMtZWFzdC0yXzVVRGhFVU9WTSIsInN1YiI6IjExZGI1NTQwLTMwMjEtNzA5NC0wNmI0LWI5NGU4NTQxZDg3NyIsImF1ZCI6IjZvYTEwOTVtMjB2Z2w0MmJuYjA5ZGNkYjNuIiwibm9uY2UiOiIiLCJpYXQiOjE3MzYyNTI3ODMsImF1dGhfdGltZSI6MTczNjI1Mjc4MiwiaWRwIjoiaHR0cHM6Ly9jb2duaXRvLWlkcC51cy1lYXN0LTIuYW1hem9uYXdzLmNvbS91cy1lYXN0LTJfNVVEaEVVT1ZNIiwiZ2l2ZW5fbmFtZSI6IlN1bmRlZXAiLCJmYW1pbHlfbmFtZSI6IlNpbmdoIiwibmFtZSI6IlNpbmdoIiwib2lkIjoiZmJlZGM0OGQtYjcyOC00N2JjLWI5ZmQtMzUxM2VmMDIyYTc2IiwiY291bnRyeSI6IlVuaXRlZCBTdGF0ZXMiLCJlbWFpbHMiOlsiU3VuZGVlcC5TaW5naEBjYXJyaWVyLmNvbSJdLCJ1c2VydHlwZSI6IkNhcnJpZXJPa3RhIiwidXNlcm5hbWUiOiJjYXJyaWVyb2t0YV8wMHVlbzJjbnlraHFtdDBsdTR4NyIsImh2YWN1c2VybmFtZSI6IjAwdWVvMmNueWtIcW1UMEx1NHg3Iiwic3RhdGUiOiIiLCJjaXR5IjoiIiwicHJpdmlsZWdlcyI6ImZhbHNlIiwiYXBwX3ByaXZpbGVnZXMiOiJmYWxzZSIsImFwcF91cmwiOiJhV1hUZm9LV1NrSTlwUzR5QXRXY0c1dVJUcGIlMkYxWDd5eGxmVFhxSkY3UDAlM0QiLCJ1c2VySWQiOjEwNTc1fQ.CNdaoXACv-SWwgcOBe6av3pfVMAZPuKA8tFAd1DAW5E";

  // Iterate over each key-value pair in the object
  for (const [key, value] of Object.entries(data)) {
    const payload = {
      Translations: {
        Key: key,
        Translations: [{ LanguageID: "en", ProjectId: 168, Value: value }],
      },
    };

    // Make a POST request using Fetch API
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log(`Success for key: ${key}`, data);
      })
      .catch((error) => {
        console.error(`Error for key: ${key}`, error);
      });
  }
};

const Main = ({
  permission,
  miscState,
  locale,
  onTabSelected,
  setSnackBar,
  getConfigGroups,
  updateMessage,
  setProjects,
  setProjectTranslations,
  updateTranslations,
}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [tabs, setTabs] = useState(CONTROLS_DATA.SCREENS.TAB_NAMES);
  const [snackbarDetails, setSnackBarDetails] = useState(miscState.snackbar);

  const readPermission = HasPermission(permission);
  const {
    fullLangCode,
    lang = "EN",
    message = {},
    leafLocale = "EN",
    transKey = "en",
    projects = [],
    projectTranslations = {},
    translations = {},
  } = locale;

  const getTranslationDataFun = async (transKey) => {
    try {
      const { data } = await cache(
        ApiService,
        [
          `${appConfig.api.translationApi}translations/getAllFromLanguageID/${TRANSLATION_API_PROJECT_ID}/${transKey}`,
        ],
        {
          storeName: "react-dmmt-platform.cache.translations",
          ttl: 60 * 60 * 24,
          saveArgs: true,
          maxItems: 15,
        }
      );

      return { data: data?.result || [] };
    } catch (error) {
      console.log("Error fetching translations: ", error);
      return {};
    }
  };

  const getProjectsData = async () => {
    await getProjects()
      .then((response) => {
        const { result = [] } = response?.data || {};
        setProjects({ projects: result });
      })
      .catch((error) => {
        console.log("get projects: ", error);
      });
  };

  const getTranslationDataForModelFun = async (transKey, msgData = {}) => {
    const [t = {}] = projects?.filter(
      (x) => x.Name === `dm_${miscState?.selectedModelName}_translation`
    );
    const modelProjectId = t?.id || null;

    if (modelProjectId) {
      setIsLoading(true);
      await gettranslationForModel(modelProjectId, transKey)
        .then((response) => {
          const { result = {} } = response?.data || {};
          setProjectTranslations(result);
          const t = { ...msgData, ...result };
          updateMessage(t);
        })
        .catch((error) => {
          console.log("get projects: ", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const init = async () => {
    const { data } = await getTranslationDataFun(transKey);

    if (data) {
      updateTranslations(data);
      updateMessage(data);
    }

    if (miscState?.selectedModel) {
      await getTranslationDataForModelFun(transKey, data);
    }
  };

  useEffect(() => {
    window.dumpTranslation = dumpTranslationData;
    getProjectsData();
    init();
  }, []);

  useEffect(() => {
    init();
  }, [leafLocale]);

  useEffect(() => {
    if (miscState?.selectedModel) {
      getTranslationDataForModelFun(transKey, translations);
    }
  }, [miscState.selectedModel]);

  const getContainer = () => {
    switch (selectedTab) {
      case 0:
        return <Models />;
      case 1:
        return <DataDescriptions />;
      case 2:
        return <Views />;
      case 3:
        return <Drawings />;
      case 4:
        return <ConfigureMsg />;
    }
  };

  /* Enable/Disable tabs */
  const updateTabs = (seletedTab, data) => {
    const updateTabs = data.map((item, index) => {
      if (seletedTab !== index) {
        return { ...item, disabled: false };
      }
      return item;
    });
    return updateTabs;
  };

  useEffect(() => {
    setSelectedTab(miscState.selectedTab);
    if (miscState.selectedTab === 0) {
      setTabs(CONTROLS_DATA.SCREENS.TAB_NAMES);
    } else {
      const tabs = updateTabs(
        miscState.selectedTab,
        CONTROLS_DATA.SCREENS.TAB_NAMES
      );
      setTabs(tabs);
    }
  }, [miscState.selectedTab]);

  useEffect(() => {
    if (miscState.selectedModel) {
      setTabs(
        tabs.map((t) => {
          return { ...t, disabled: false };
        })
      );
    }
  }, [miscState.selectedModel]);

  useEffect(() => {
    if (miscState?.selectedModel) getConfigGroups(miscState.selectedModel);
  }, [miscState.selectedModel]);

  useEffect(() => {
    setSnackBarDetails(miscState.snackbar);
  }, [miscState.snackbar]);

  return (
    <IntlProvider locale={lang} messages={message}>
      <>
        <Loading open={isLoading} />
        <Header permission={permission} />
        {readPermission ? (
          <>
            <DMTabContainer
              tabs={tabs}
              defaultActiveTab={selectedTab}
              onTabChange={onTabSelected}
              alignment={"center"}
            />
            <div>{getContainer()}</div>
          </>
        ) : (
          <Error />
        )}
        <Snackbar
          open={snackbarDetails?.show}
          autoHideDuration={3000}
          onClose={() => setSnackBar(false, "", "")}
          style={{ zIndex: "111111" }}
        >
          <Alert
            onClose={() => setSnackBar(false, "", "")}
            severity={snackbarDetails?.severity}
          >
            {snackbarDetails?.message}
          </Alert>
        </Snackbar>
        <Footer />
      </>
    </IntlProvider>
  );
};
const mapStateToProps = (state) => ({
  miscState: state.misc,
  locale: state.locale,
});

const mapDispatchToProps = (dispatch) => {
  return {
    onTabSelected: (tabId) => dispatch(miscAction.onTabSelected(tabId)),
    getConfigGroups: async (requestPayload) =>
      dispatch(dataDescriptionAction.getConfigGroups(requestPayload)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    updateMessage: async (data) => {
      dispatch({
        type: UPDATE_MESSAGES,
        data: {
          ...data,
        },
      });
    },
    updateTranslations: async (data) => {
      dispatch({
        type: UPDATE_TRANSLATIONS,
        data: {
          ...data,
        },
      });
    },
    setProjects: async (data) => {
      dispatch({
        type: LOCALE_SET_PROJECTS,
        data: {
          ...data,
        },
      });
    },
    setProjectTranslations: async (data) => {
      dispatch({
        type: LOCALE_SET_PROJECTS_TRANSLATIONS,
        data: {
          ...data,
        },
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
